import styles from "./SustainQueueScreen.style";

export default styles;
